export const LOGIN_RESPONSE_ERROR = {
  userOrPasswordInvalid: 'SRV000000202',
  accessError: 'SRV000000203',
  passwordNeedsToBeReplaced: 'SRV000000206',
  loginTemporarilyBlocked: 'SRV000000201',
  loginFromWrongTerritory: 'SRV000000208'
};
